// Enum VacancyCandidateStatus
export const VACANCY_CANDIDATE_STATUS_PREHIRED = "PreHired";
export const VACANCY_CANDIDATE_STATUS_HIRED = "Hired";

// Enum VoiceTestCandidateStatus
export const VOICE_TEST_CANDIDATE_STATUS_PREHIRED = "PreHired";
export const VOICE_TEST_CANDIDATE_STATUS_HIRED = "Hired";
export const VOICE_TEST_CANDIDATE_STATUS_PRECONFIRMED = "PreConfirmed";
export const VOICE_TEST_CANDIDATE_STATUS_CONFIRMED = "Confirmed";

// Enum ProfileType
export const PROFILE_TYPE_DIRECTOR = "Director";
export const PROFILE_TYPE_TRANSLATOR = "Translator";
export const PROFILE_TYPE_VOICEACTOR = "VoiceActor";
export const PROFILE_TYPE_SINGER = "Singer";
export const PROFILE_TYPE_ADAPTOR = "Adaptor";
export const PROFILE_TYPE_LYRICIST = "Lyricist";
export const PROFILE_TYPE_EDITOR = "Editor";
export const PROFILE_TYPE_SOUNDENGINEER = "SoundEngineer";
export const PROFILE_TYPE_BOOKER = "Booker";

// Enum ProfileStatus
export const PROFILE_STATUS_PENDINGQUALIFICATION = "PendingQualification";
export const PROFILE_STATUS_QUALIFIED = "Qualified";
export const PROFILE_STATUS_REJECTED = "Rejected";

// Enum WorkAmountUnit
export const WORK_AMOUNT_UNIT_FLATFEE = "FlatFee";

// Enum AdminPermission
export const PERMISSION_ARTICLES_READ = "ArticlesRead";
export const PERMISSION_ARTICLES_WRITE = "ArticlesWrite";
export const PERMISSION_MAP_CHARTS_READ = "GeoChartsRead";
export const PERMISSION_MAP_CHARTS_WRITE = "GeoChartsWrite";
export const PERMISSION_PRODUCTIONS_READ = "ProductionsRead";
export const PERMISSION_PRODUCTIONS_WRITE = "ProductionsWrite";
export const PERMISSION_TALENTS_READ = "TalentsRead";
export const PERMISSION_TALENTS_READ_GLOBAL = "TalentsReadGlobal";
export const PERMISSION_TALENTS_WRITE = "TalentsWrite";
export const PERMISSION_ADMINMESSAGES_READ = "AdminMessagesRead";
export const PERMISSION_ADMINMESSAGES_WRITE = "AdminMessagesWrite";
export const PERMISSION_TALENTS_PROFILE_DIRECTOR_WRITE = "TalentsProfileDirectorWrite";
export const PERMISSION_TALENTS_PROFILE_TRANSLATOR_WRITE = "TalentsProfileTranslatorWrite";
export const PERMISSION_TALENTS_PROFILE_VOICEACTOR_WRITE = "TalentsProfileVoiceActorWrite";
export const PERMISSION_TALENTS_PROFILE_SINGER_WRITE = "TalentsProfileSingerWrite";
export const PERMISSION_TALENTS_PROFILE_ADAPTOR_WRITE = "TalentsProfileAdaptorWrite";
export const PERMISSION_TALENTS_PROFILE_LYRICIST_WRITE = "TalentsProfileLyricistWrite";
export const PERMISSION_TALENTS_PROFILE_EDITOR_WRITE = "TalentsProfileEditorWrite";
export const PERMISSION_TALENTS_PROFILE_SOUNDENGINEER_WRITE = "TalentsProfileSoundEngineerWrite";
export const PERMISSION_TALENTS_PROFILE_BOOKER_WRITE = "TalentsProfileBookerWrite";
export const PERMISSION_VACANCIES_READ = "VacanciesRead";
export const PERMISSION_VACANCIES_WRITE = "VacanciesWrite";
export const PERMISSION_VACANCIES_CRITERIA_WRITE = "VacanciesCriteriaWrite";
export const PERMISSION_VACANCIES_CANDIDATES_DIRECTOR_SUGGEST = "VacanciesCandidatesDirectorSuggest";
export const PERMISSION_VACANCIES_CANDIDATES_TRANSLATOR_SUGGEST = "VacanciesCandidatesTranslatorSuggest";
export const PERMISSION_VACANCIES_CANDIDATES_VOICEACTOR_SUGGEST = "VacanciesCandidatesVoiceActorSuggest";
export const PERMISSION_VACANCIES_CANDIDATES_SINGER_SUGGEST = "VacanciesCandidatesSingerSuggest";
export const PERMISSION_VACANCIES_CANDIDATES_ADAPTOR_SUGGEST = "VacanciesCandidatesAdaptorSuggest";
export const PERMISSION_VACANCIES_CANDIDATES_LYRICIST_SUGGEST = "VacanciesCandidatesLyricistSuggest";
export const PERMISSION_VACANCIES_CANDIDATES_EDITOR_SUGGEST = "VacanciesCandidatesEditorSuggest";
export const PERMISSION_VACANCIES_CANDIDATES_SOUNDENGINEER_SUGGEST = "VacanciesCandidatesSoundEngineerSuggest";
export const PERMISSION_VACANCIES_CANDIDATES_BOOKER_SUGGEST = "VacanciesCandidatesBookerSuggest";
export const PERMISSION_VACANCIES_CANDIDATES_DIRECTOR_BOOK = "VacanciesCandidatesDirectorBook";
export const PERMISSION_VACANCIES_CANDIDATES_TRANSLATOR_BOOK = "VacanciesCandidatesTranslatorBook";
export const PERMISSION_VACANCIES_CANDIDATES_VOICEACTOR_BOOK = "VacanciesCandidatesVoiceActorBook";
export const PERMISSION_VACANCIES_CANDIDATES_SINGER_BOOK = "VacanciesCandidatesSingerBook";
export const PERMISSION_VACANCIES_CANDIDATES_ADAPTOR_BOOK = "VacanciesCandidatesAdaptorBook";
export const PERMISSION_VACANCIES_CANDIDATES_LYRICIST_BOOK = "VacanciesCandidatesLyricistBook";
export const PERMISSION_VACANCIES_CANDIDATES_EDITOR_BOOK = "VacanciesCandidatesEditorBook";
export const PERMISSION_VACANCIES_CANDIDATES_SOUNDENGINEER_BOOK = "VacanciesCandidatesSoundEngineerBook";
export const PERMISSION_VACANCIES_CANDIDATES_BOOKER_BOOK = "VacanciesCandidatesBookerBook";
export const PERMISSION_ADMIN_USERS_READ = "AdminUsersRead";
export const PERMISSION_ADMIN_USERS_WRITE = "AdminUsersWrite";

export const PERMISSION_VACANCIES_CONTRACTS_MANAGE = "VacanciesContractsManage";
export const PERMISSION_CLIENTS_ACCOUNTS_MANAGEMENT = "ClientsAccountsManagement";
